<template>
  <div >
    <van-field name="radio" label="" :rules="[{ required: true, message: '请选择' }]" error-message-align="center">
      <template #input>
        <van-radio-group v-model="radio" @change="handleRadio">
            <van-radio 
            :name="item.name" 
            v-for="(item,index) in radioList" 
            :key="index" 
            class="f_radio" 
            checked-color="#0b0343">
                {{item.name}}
                <input class="myInput" v-if="radio == '其他' && item.name =='其他'" v-model="value" maxlength="29"/>
            </van-radio>
        </van-radio-group>
      </template>
    </van-field>
  </div>
</template>
<script>
import {debounce} from 'lodash'
export default {
  data() {
    return {
      radio: "",
      value: ""
    };
  },
  //接收来自父组件的数据
  props: {
    radioList: {
      type: Array,
      default: () => []
    },
    defaultValue:{
      type:String,
      default:() => ''
    },
    text:{
      type:String,
      default:() => ''
    },
  },

  //生命周期实例创建完成后被立即调用
  created() {},
  //生命周期挂载完成之后被调用
  mounted() {
    this.radio = this.defaultValue;
    this.value = this.text;
  },
  //组件
  components: {},
  //方法
  methods: {
    handleRadio(val) {
      //console.log(this.radio);
      if (this.radio == "其他" && val == "其他") {
        this.$emit("handleRadio", val, this.value);
      } else {
        this.$emit("handleRadio", val);
      }
    }
  },
  //监视
  watch: {
    value: debounce(function(val) {
      this.$emit("handleRadio", this.radio, val);
    },500),
    defaultValue: function(val) {
      if (val) {
        this.radio = val
      }
    },
  }
};
</script>
<style lang="less" scoped>
/deep/.van-radio {
  box-sizing: border-box;
  padding: 20px 20px 20px 30px;
  border-bottom: solid 1px #e5e5e5;
}
/deep/.van-cell {
  width: 100%;
  padding: 0;
}
/deep/.van-field__value {
  width: 100%;
}
/deep/.van-radio-group {
  width: 100%;
}
.myInput {
  width: 490px;
  height: 64px;
  border-radius: 10px;
  margin-left: 30px;
  border: none;
  background: #e5e5e5;
  box-sizing: border-box;
  padding: 0 15px;
}
</style>